export default __webpack_public_path__ + "static/media/ASR_MONTAJ_URUN_BAZLI.49f79ab2.xlsx";